module.exports = __webpack_public_path__ + "img/VA.1825a39f.svg";